import { Link } from 'react-router';

import { Button, Popover, PopoverContent, PopoverTrigger } from '@app-evolution-cms/element-ui';

import { config } from '../../config';

const IS_DEV_ENV = config().IS_DEV_ENV;
const IS_STG_ENV = config().IS_STG_ENV;

const CMS_URLS = {
  dev: 'https://cms-dev.gbm-tools.com',
  stg: 'https://cms-stg.gbm-tools.com',
  prd: 'https://cms.gbm-tools.com',
} as const;

export function EnvBadge() {
  if (IS_DEV_ENV || IS_STG_ENV) {
    const availableCMSLinks = IS_DEV_ENV
      ? [
          { label: 'staging', url: CMS_URLS.stg },
          { label: 'producción', url: CMS_URLS.prd },
        ]
      : [
          { label: 'desarrollo', url: CMS_URLS.dev },
          { label: 'producción', url: CMS_URLS.prd },
        ];

    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button className="text-xs font-bold tracking-wide" size="icon" variant="accent">
            {IS_DEV_ENV ? 'DEV' : 'STG'}
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" side="bottom">
          <p className="text-sm">
            Estás usando el ambiente de{' '}
            <span className="text-accent">{IS_DEV_ENV ? 'desarrollo' : 'staging'}</span>
          </p>
          <p className="mt-2 text-sm">Ir a:</p>
          <ul className="list-disc pl-4">
            {availableCMSLinks.map(({ label, url }) => (
              <li key={label}>
                <Link
                  className="rounded-3xl"
                  rel="noopener noreferrer"
                  tabIndex={-1}
                  target="_blank"
                  to={url}
                >
                  <Button className="h-6 p-0" size="sm" variant="link">
                    {label}
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
        </PopoverContent>
      </Popover>
    );
  }

  return null;
}
